import { useState, useEffect } from "react";
import { MessageCircle, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "../data/content";

export function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={`https://wa.me/${CONTACT.whatsapp}?text=Bonjour%20Optimeo%20Habitat,%20je%20souhaite%20des%20informations%20sur%20la%20r%C3%A9novation%20%C3%A9nerg%C3%A9tique.`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 md:bottom-6 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform pulse-glow"
      aria-label="Contacter par WhatsApp"
    >
      <MessageCircle className="w-6 h-6 text-white" />
    </a>
  );
}

export function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-black/95 backdrop-blur-xl border-t border-white/10 px-4 py-3 flex gap-2"
    >
      <a
        href={`tel:${CONTACT.phoneLink}`}
        data-testid="sticky-call-btn"
        className="flex-1 bg-white/10 border border-white/10 rounded-full py-3 text-white text-sm font-bold flex items-center justify-center gap-2"
      >
        <Phone className="w-4 h-4" /> Appeler
      </a>
      <Link
        to="/devis"
        data-testid="sticky-devis-btn"
        className="flex-1 bg-[#7DD923] text-black rounded-full py-3 text-sm font-bold flex items-center justify-center uppercase tracking-wider"
      >
        Étude gratuite
      </Link>
    </div>
  );
}

export function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (shown) return;
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !shown) {
        setOpen(true);
        setShown(true);
      }
    };
    const timer = setTimeout(() => {
      if (!shown && !sessionStorage.getItem("optimeo_popup")) {
        // Fallback trigger after 25s
        setOpen(true);
        setShown(true);
        sessionStorage.setItem("optimeo_popup", "1");
      }
    }, 25000);
    document.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
      clearTimeout(timer);
    };
  }, [shown]);

  if (!open) return null;

  return (
    <div
      data-testid="exit-intent-popup"
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={() => setOpen(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="glass rounded-3xl max-w-lg w-full p-8 relative overflow-hidden"
      >
        <div className="blob" style={{ background: "#7DD923", width: 220, height: 220, top: -80, right: -80, opacity: 0.25 }} />
        <div className="relative z-10">
          <div className="eyebrow">Attendez !</div>
          <h3 className="font-display uppercase text-white text-3xl mt-3 leading-tight">
            Ne partez pas sans<br/>votre étude gratuite
          </h3>
          <p className="text-white/70 mt-4 text-sm">
            En 2 minutes, découvrez le montant des aides auxquelles vous avez droit. C'est gratuit et sans engagement.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <Link
              to="/simulateur"
              data-testid="popup-cta-simulateur"
              onClick={() => setOpen(false)}
              className="btn-primary justify-center flex-1"
            >
              Simuler mes aides
            </Link>
            <button
              data-testid="popup-close-btn"
              onClick={() => setOpen(false)}
              className="btn-secondary justify-center flex-1"
            >
              Non merci
            </button>
          </div>
          <div className="flex items-center gap-4 mt-6 text-xs text-white/50">
            <a href={`tel:${CONTACT.phoneLink}`} className="flex items-center gap-1 hover:text-white"><Phone className="w-3.5 h-3.5" /> {CONTACT.phoneDisplay}</a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-1 hover:text-white"><Mail className="w-3.5 h-3.5" /> {CONTACT.email}</a>
          </div>
        </div>
      </div>
    </div>
  );
}
